import type { Content as ContentType } from 'types/capi/content';

import Content from '~/components/Content';
import { contentTextWidth } from '~/components/Content/textWidth';

type Props = {
  content?: ContentType[];
  title?: string;
};

export function ContentBlockCore({ content, title }: Props) {
  const items = content ?? [];
  if (!title && items.length === 0) return null;

  return (
    <>
      {title && <h3 className="w-full text-lg font-bold">{title}</h3>}
      {items.length > 0 && <Content content={items} />}
    </>
  );
}

export default function ContentBlock({ content, title }: Props) {
  const items = content ?? [];
  if (!title && items.length === 0) return null;

  return (
    <div className="flex w-full items-center justify-center px-10 max-md:px-4">
      <div className={`flex ${contentTextWidth} flex-col gap-6`}>
        <ContentBlockCore content={content} title={title} />
      </div>
    </div>
  );
}
